<app-grid-container [columns]="16"
                    [rows]="9"
                    class="flex-stretch">

  <!-- Card -->
  @if (cardContentTemplate) {
    <app-card appGridItem
              [shadow]="true"
              [column]="6"
              [row]="3"
              [width]="6"
              [height]="5">
      <div class="full-height-stack">

        <!-- Title and separator -->
        <app-card-title [faIcon]="cardIcon"
                        size="large">
        <span appPageTitle>
          {{ cardTitle }}
        </span>
        </app-card-title>

        <!-- Projected content -->
        <ng-container [ngTemplateOutlet]="cardContentTemplate"></ng-container>
      </div>
    </app-card>

  <!-- Any other content -->
  } @else if (anyContentTemplate) {
    <ng-container [ngTemplateOutlet]="anyContentTemplate"></ng-container>
  }

  <!-- any2any logo -->
  @if (showLogo) {
    <div class="logo-container"
         appGridItem
         [column]="12"
         [row]="9"
         [width]="5"
         [height]="1">
      <app-any2any-logo
        [heightPx]="60">
      </app-any2any-logo>
    </div>
  }
</app-grid-container>
